module.exports = __webpack_public_path__ + "img/logo.e5939f38.png";